import { setCurrentSite, setWorkingAddress } from '../../store/authSlice'
import { useAppDispatch } from '../../store/store.hooks'
import { Site } from '../../types/site.types'
import { logger } from '../../utils/logger'
import { fetchAddressCandidate } from '../services/apiService'
import { siteService } from '../services/site.service'
import { userService } from '../services/user.service'

export const useSelectSite = () => {
  const dispatch = useAppDispatch()

  const selectSite = async (site: Site) => {
    logger.log('Navigating to site:', site)
    dispatch(setCurrentSite(site))
    const [siteDetails, , addressCandidates] = await Promise.all([
      siteService.fetchSiteDetails(site.id),
      userService.updateLastVisitedSite(site.id),
      fetchAddressCandidate(site.id),
    ])
    dispatch(setCurrentSite(siteDetails))
    const hostAddress = addressCandidates[0]?.hostAddress
    if (hostAddress) {
      logger.log('[SelectSite] workingAddress:', hostAddress)
      dispatch(setWorkingAddress(hostAddress))
    }
  }

  return { selectSite }
}
